import {Position, positionDecoder} from './Position'
import {Decoder, field, number, object} from 'json-bouncer'

export interface OpenPosition {
    position: Position
    remainingAmount: number
}

export function openPositionDecoder(): Decoder<OpenPosition> {
    return object({
        position: field('position', positionDecoder()),
        remainingAmount: field('remainingAmount', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OpenPosition.ts